module.exports = __webpack_public_path__ + "img/logo_txt.f3848be0.png";